import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import './design-guidelines-styles.css';
export const _frontmatter = {
  "pageTitle": "Selects Design Guidelines",
  "title": "Select",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PageContent componentName="select" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  The Select component allows users to choose one or more options from a list.
  It is used in forms for users to submit data.
      </LeadParagraph>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "44.4015444015444%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAeUlEQVQoz52R0QrDMAhF+//fmZc8OXX3hoTWDdJtLCsjpedN5MhVF4zcOwBIYsbyXZDMOaeURMQ7n5b7a+hfGcCto6oiQrK+ATiXAZhZay0itoF1EntPrqq11sdIRJyS3f26bGYXZQCqWkrZfjZeT+y8/9nd7cDx2k/siwdWeAA7IwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": " ",
            "title": " ",
            "src": "/version/4.9.1/static/447f000909e78239df03a23f8b48d01d/e3189/selects-intro-image.png",
            "srcSet": ["/version/4.9.1/static/447f000909e78239df03a23f8b48d01d/a2ead/selects-intro-image.png 259w", "/version/4.9.1/static/447f000909e78239df03a23f8b48d01d/6b9fd/selects-intro-image.png 518w", "/version/4.9.1/static/447f000909e78239df03a23f8b48d01d/e3189/selects-intro-image.png 1035w", "/version/4.9.1/static/447f000909e78239df03a23f8b48d01d/aa440/selects-intro-image.png 1500w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
      <hr></hr>
      <h2>{`Select vs. Dropdown`}</h2>
      <p>{`While the Select and Dropdown components can look similar, they have different functions.`}</p>
      <ul>
        <li parentName="ul">{`Use the Select component inside a form where users are selecting from a list of options and submitting data.`}</li>
        <li parentName="ul">{`Use the Dropdown component to display a list of menu options.`}</li>
      </ul>
      <hr></hr>
      <h2>{`Multiselect`}</h2>
      <p>{`Multiselects are exactly what the name implies – A Select input that allows the user to choose multiple values to be submitted at the same time. Previously selected options may be removed with the associated close/remove button.`}</p>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "41.69884169884169%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAAsTAAALEwEAmpwYAAABDElEQVQY04WPzUrDUBCF8wC+gAji2/gI3RYVN+78WUtduRQEXaQitnQh7QO4dFFSsBUXFTSmSNUITaiEmzsz9+YmzQhiwQZaP872OzPHwlkAUEqQ8BMJuBCrYCpNWaqMoTRVqVEw5R8ZALVWnue3HbfbHXQc1+k8D1/fQQgQMo4ESLlINkbd9fxzu19vvly2Ble1x684YWaVTSjPQRHOvmAVygjBcEL3T9FRPTqshZVGUGmEx9ej/ap48ChN/vpFGYREzsf2zdtS6WN183Nty18p+8vlobUeNW+Jc4zlXBklUGZEux/snIUHF+FeNdy1g+3T0cZJ3HMxMyjnX/5dn2jinHgyDRMzal3Y/A3RJ7CKNAodIgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": " ",
            "title": " ",
            "src": "/version/4.9.1/static/3a13c278b9450c81ad1ba84496876c8e/e3189/multi-select-example.png",
            "srcSet": ["/version/4.9.1/static/3a13c278b9450c81ad1ba84496876c8e/a2ead/multi-select-example.png 259w", "/version/4.9.1/static/3a13c278b9450c81ad1ba84496876c8e/6b9fd/multi-select-example.png 518w", "/version/4.9.1/static/3a13c278b9450c81ad1ba84496876c8e/e3189/multi-select-example.png 1035w", "/version/4.9.1/static/3a13c278b9450c81ad1ba84496876c8e/aa440/multi-select-example.png 1500w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      